import Vue from 'vue'
import Router from 'vue-router'

import Survey from '../components/survey/Survey.vue'

Vue.use(Router)

export default new Router({
  base: process.env.environment === 'development' ? '/' : '/find-your-ideal-station/',
  routes: [
    {
      path: '/:step',
      name: 'Survey Step',
      component: Survey
    },
    {
      path: '/',
      name: 'Survey',
      component: Survey
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js